//import WavForm from "images/wavform.jpg"

export const styles = (theme) => ({
     root: {
        //backgroundImage: `url(${WavForm})`,
        height: 37,
        cursor: "pointer",
        marginTop: -1,
        borderRadius:"5px",
        background: "#8f8f8f",
        overflow: "hidden",
      },
      colorPrimary: {
        //         backgroundColor: 'rgb(255 255 255 / 20%)',
        backgroundColor: 'transparent',
        height:"58px",
        borderRadius:"5px"
      },
      barColorPrimary: {
        backgroundColor: 'rgb(31 40 90 / 60%)',
        height:"58px",
        borderRadius:"5px"
      },
      dashedColorPrimary: {
        background: "none",
      },
      dashedColorPrimaryActive: {
        backgroundSize: "10px 10px" ,
        backgroundImage: "radial-gradient(rgb(31, 40, 90) 0%, rgb(31, 40, 90) 16%, transparent 42%)",
        backgroundPosition: "0 -23px",
        height:"58px",
        borderRadius:"5px"
      },
      TrackDuration:{
        fontSize: "11px",
        marginTop: "16px",
        position: "absolute",
        right: "92px",
      },
      waveNotFound :{
        display: 'none'
      }, 
      waveForm:{
        borderRadius: "5px",
        backgroundSize:" 100% 100% !important",
        backgroundRepeat:" no-repeat",
        backgroundPosition: "center",
        position:"relative",
        "& .waveImage":{
          // filter: "brightness(0) invert(1)",
          width: "100%",
          height: "35px",
          position: "absolute",
          imageRendering: "pixelated !important",
          top: "1px",
        },
        "& .waveImageInBuilt":{
          width: "100%",
          height: "auto",
          position: "absolute",
          maxWidth: "90px",
          left:"0",
          right:"0",
          margin:"12px auto",
        }
      },
      barSize:{
        height:"54px",
        borderRadius:"5px",
      },
     
   
});
